<template>
	<!-- 企业用户管理 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.coName" placeholder="企业名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getListPage">查询</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="companylist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
      			
      		<el-table-column prop="userName" label="企业名称"  align="center" min-width="100">
		 	</el-table-column>

			<el-table-column prop="cityName" label="所属城市"  align="center" min-width="100">
		 	</el-table-column>	

			<el-table-column prop="locked" label="用户状态" align="center" min-width="100" >
				<template slot-scope="scope">
				<!-- 不同状态显示不同颜色的文字 -->
				<div v-if='scope.row.locked==="0"'>
					<span style="color: green;">正常</span>
				</div>
					
				<div v-else>
					<span style="color: red;">禁用</span>
				</div>
				</template>
			</el-table-column>

			<el-table-column label="操作" align="left" width="200">
				<template slot-scope="scope">
					<el-button v-if="scope.row.locked=='0'"  type="danger" size="small" @click="handleClose(scope.$index, scope.row)">禁用</el-button>
					<el-button v-if="scope.row.locked=='1'" type="success" size="small" @click="handleOpen(scope.$index, scope.row)">启用</el-button>
					<el-button type="primary" size="small" @click="handleresetpwd(scope.$index, scope.row)">重置密码</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
	</section>
</template>

<script>
	import {getAccountList,updateAccount,resetAccountpwd} from '../../api/api';

	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id

				filters: {
					coName: ''
				},

				companylist: [],
				total: 0,
				page: 1,
				listLoading: false,			
			}
		},
		methods: {
			
			handleCurrentChange(val) {				
				this.page = val;
				this.getListPage();
			},
			//获取列表
			getListPage() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
					coName:this.filters.coName
				};

				this.listLoading = true;

				getAccountList(para).then((res) => {


					if(res.data.code==0){
						this.total = res.data.data.total;
						this.companylist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			handleClose: function (index, row) {
				this.$confirm('确认禁用这个账号吗？', '提示', {}).then(() => {

					let newparam={
						createUserId:this.objectId,
						accountId:row.accountId,
						locked:'1'
					}

					updateAccount(newparam).then((res) => {
						if(res.data.code==0){
						this.$message.success(res.data.message);
						this.getListPage();
						}
						else{
						this.$message.error(res.data.message);
						}
					});
				});	
			
			},
			
			handleOpen: function (index, row) {
				this.$confirm('确认启用这个账号吗？', '提示', {}).then(() => {

					let newparam={
						createUserId:this.objectId,
						accountId:row.accountId,
						locked:'0'
					}

					updateAccount(newparam).then((res) => {
						if(res.data.code==0){
						this.$message.success(res.data.message);
						this.getListPage();
						}
						else{
						this.$message.error(res.data.message);
						}
					});
				});	
			},
		
			handleresetpwd: function (index, row) {
				this.$confirm('确认重置这个账号的密码吗？', '提示', {}).then(() => {

					let newparam={
						createUserId:this.objectId,
						accountId:row.accountId,
					}

					resetAccountpwd(newparam).then((res) => {
						if(res.data.code==0){
						this.$message.success(res.data.message);
						}
						else{
						this.$message.error(res.data.message);
						}
					});
				});	
			},
		
			
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.getListPage();
		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// accountManager.vue?1a6e99b0